export default __webpack_public_path__ + "785c6b789ebecfc21e97a0dcd06324a6.png";